import GetPWT from "components/shared/GetPWT/GetPWT";

GetPWT.getPWTAndGPT();